module.exports = __webpack_public_path__ + "media/images/login/text_btn_ov-4e712497bd7ba946f87c333450244836.png";